var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('busi-form',{ref:"busiform",attrs:{"vo":_vm.vo,"can-edit":_vm.canEdit,"module-info":_vm.moduleInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }